import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';
//import { set } from '../../../server/src/login/loginAuth';
axios.defaults.withCredentials = true;

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUserRole, setCurrentUserRole] = useState('user');
    const [authChecked, setAuthChecked] = useState(false);

    const login = () => setIsLoggedIn(true);

    const logout = useCallback(async () => {
        try {
            const response = await axios.post('/api/logoutSQL');
            
            if (response.data.message) {
                 console.log(`${response.data.message}`);
            }

        } catch (error) {
            console.log("Error Logging Out", error);
        } finally {
            setIsLoggedIn(false);
            setCurrentUserRole('user');
            window.location.reload(true);
        }
    }, []);


    const checkAuthentication = useCallback(async () => {
        try {
            const response = await axios.get('/api/tokenCheckSQL');

            if (response.data.authentication) {
                setIsLoggedIn(true);
                setCurrentUserRole(response.data.currentUserRole);
            } else {
                setIsLoggedIn(false);
                setCurrentUserRole('user');
            }
        } catch (err) {
            setIsLoggedIn(false);
            setCurrentUserRole('user');
            console.log("Authentication check error", err);
        } finally {
            setAuthChecked(true);
        }
    }, []);

    /*const refreshAccessToken = useCallback(async () => {
        try {
            // Retrieve the refresh token from localStorage
            const refresh_token = localStorage.getItem('refreshToken');

            if (!refresh_token) {
                console.log('Refresh token not available');
                return;
            }

            const refreshResponse = await axios.post('/api/refreshSQL', { refreshToken: refresh_token }, { withCredentials: true });
            const newAccessToken = refreshResponse.data.token;

            // Update the access token in localStorage
            localStorage.setItem('authToken', newAccessToken);
            setIsLoggedIn(true);
            setCurrentUserRole(refreshResponse.data.currentUserRole);
        } catch (error) {
            console.log('Error refreshing access token', error);
            logout();
        }
    }, [logout]);*/
    // 🔥 AXIOS INTERCEPTOR FOR AUTO REFRESH
    useEffect(() => {
        // A 401 from these means wrong details, not an expired session: refreshing would fail and
        // log out, and logging out reloads the page, wiping the login form's error message.
        const NO_REFRESH = ['/api/refreshSQL', '/api/signinSQL'];

        const interceptor = axios.interceptors.response.use(
            response => response,
            async error => {
                const originalRequest = error.config;

                if (
                    error.response?.status === 401 &&
                    !originalRequest._retry &&
                    !NO_REFRESH.some((path) => originalRequest.url.includes(path))
                ) {
                    originalRequest._retry = true;

                    try {
                        const refreshResponse = await axios.post('/api/refreshSQL');

                        if (refreshResponse.data.authentication) {
                            setIsLoggedIn(true);
                            setCurrentUserRole(refreshResponse.data.currentUserRole);

                            return axios(originalRequest); // retry original request
                        }

                    } catch (refreshError) {
                        logout();
                    }
                }

                return Promise.reject(error);
            }
        );

        return () => axios.interceptors.response.eject(interceptor);
    }, [logout]);

    useEffect(() => {
        checkAuthentication();
    }, [checkAuthentication]);

    // The site renders straight away instead of waiting for this check. Pages that depend on
    // being logged in read authChecked and wait themselves (see RoutesBlog).
    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout, setCurrentUserRole, currentUserRole, authChecked }}>
            {children}
        </AuthContext.Provider>
    );
};